<template>
    <base-dialog :value="dialog" :width="500" :fullscreen="isMobile" :title="$t('ai.rec_title')"
        @input="val => { if (!val) hide() }" @close="hide">
        <ai-recommendation-card v-if="studentId" :key="studentId" :student-id="studentId" embedded @close="hide" />
    </base-dialog>
</template>

<script>
import BaseDialog from '@/components/common/BaseDialog'
import AiRecommendationCard from '@/components/coach/ai/AiRecommendationCard'

export default {
    name: 'AiRecommendationDialog',

    components: { BaseDialog, AiRecommendationCard },

    data() {
        return {
            dialog: false,
            studentId: null,
        }
    },

    methods: {
        show(studentId) {
            this.studentId = studentId
            this.dialog = true
        },
        hide() {
            this.dialog = false
        },
    },
}
</script>
